import { useEffect, useState } from "react";
import { soulManager } from "../../data/managers/SoulManager";
import { PlanModel } from "../../data/models/Soul/PlanModel";

export function useAnalytics(enabled = true) {
  const [currentPlan, setCurrentPlan] = useState<PlanModel | undefined>();
  const [previousPlan, setPreviousPlan] = useState<PlanModel | undefined>();
  const [loading, setLoading] = useState(true);
  const [showCurrent, setShowCurrent] = useState(true);

  useEffect(() => {
    document.title = "LyPro AI - Analytics";
    if (!enabled) {
      setLoading(false);
      return;
    }
    getPlans();
  }, [enabled]);

  async function getPlans() {
    setLoading(true);
    const res = await soulManager.getSoulPlan();
    setCurrentPlan(res?.currentPlan);
    setPreviousPlan(res?.previousPlan);
    setLoading(false);
  }

  const plan = showCurrent ? currentPlan : previousPlan;

  return {
    plan,
    loading,
    showCurrent,
    setShowCurrent,
    getPlans,
  };
}
